import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../services/base.service';
import { Environment } from '../../shared/models/environment';
import { AppService } from '../../app.service';
import { IResponse } from '../../shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { EncryptionService } from '../services/encryption.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService extends BaseService implements OnDestroy {
  private environment: Environment = Environment.getInstance();
  private readonly ngUnsubscribe = new Subject<void>();
  constructor(protected http: HttpClient, private appService: AppService, private cacheService: CacheResolverService, private encryptionService: EncryptionService) {
    super(http);
  }

  getConfig() {
    var configUrl = window.location.hostname;
    const emailUrl = new URL(window.location.href);
    const emailQueryParams = emailUrl.search;
    const queryParamsToCheck = ['message=', 'submitForReview=', 'approveEvent=', 'rejectEvent=', 'closerEvent=', 'taskTab=', 'dispositionTab='];
    const emailLinkStoreParams = !this.encryptionService.decryptData(localStorage.getItem("email-query-params")) && queryParamsToCheck.some(param => emailQueryParams.includes(param));

    if (emailLinkStoreParams) {
      localStorage.setItem('email-query-params', this.encryptionService.encryptData(emailQueryParams));
    }

    if (configUrl.includes('localhost')) {
      configUrl ='https://holdandrecall-ui-dev.apps.cf.np.gc.cahcloud.net/env/prop';
      // configUrl ='https://holdandrecall-ui-stg.apps.cf.np.gc.cahcloud.net/env/prop';
    } else {
      configUrl = '/env/prop';
    }
    return new Promise((resolve) => {
      this.http.get(configUrl).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: IResponse) => {
        if (!response.hasError) {
          this.onConfigResponse(response);
          this.appService.init();
          this.appService.initOnLoad().then((load) => {
            if (load) {
              this.appService.load().then(() => {
                resolve(true);
              });
            } else {
              resolve(true);
            }
          });
        }
      });
    });
  }

  public onConfigResponse(response): void {
    this.environment.appConfig.appLoaded = true;
    this.environment.appConfig.apiTimeOut = 30;
    this.environment.appConfig.appTimeOut = 120;
    this.environment.apiConfig = {
      apiUrl: response.apiUrl,
      holdUrl: response.holdUrl,
      loginUrl: response.loginUrl,
      jwtUrl: response.jwtUrl,
      externalUrl: response.externalUrl,
      redirectUrl: response.redirectUrl,
      extRedirectUrl: response.extRedirectUrl,
      clientId: response.clientId,
      reportUrl: response.reportUrl,
      groupId: response.groupId,
      siteKey: response.siteKey,
      textMaxLength:response.textMaxLength,
      externalLogin: response.externalUrl + '/oauth2/v1/authorize?response_mode=query&grant_type=autorozation_code&client_id=' + response.clientId +
        '&redirect_uri=' + response.extRedirectUrl +
        '&code_challenge_method=S256&code_challenge=hJsotKFMtXKq6b9MsqhYCUo4pn7RsnDd_5xdfzu47rQ&response_type=code&scope=openid&state=state-8600b31f-52d1-4dca-987c-386e3d8967e9%26&code=GG2rxV1NVSka2ldqlXxN9u1rdqhMc8TonG-fD59NZPA'
    };
  
    this.cacheService.set('text-max-length', response.textMaxLength);
    this.environment.oktaConfig = {
      clientId: response.clientId,
      issuer: response.externalUrl,
      scope: 'openid email',
    };
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
